import type { IconSize } from "@circleco/compass/components/Icon";
import { IconButton } from "@circleco/compass/components/IconButton";
import { Tooltip } from "@circleco/compass/components/Tooltip";
import { useNavigate } from "@tanstack/react-router";

import { t } from "@/i18n-js/instance";
import { memberProfileModalPaths } from "@/react/helpers/urlHelpers";
import { usePreviousLocationState } from "@/react/hooks/usePreviousLocationState";

export const NotificationSettingsButton = ({
  iconSize = "md",
}: {
  iconSize?: IconSize;
}) => {
  const navigate = useNavigate();
  const previousLocationState = usePreviousLocationState();

  return (
    <Tooltip content={t("header_v3.notification_settings")}>
      <IconButton
        icon="settings-gear"
        size={iconSize}
        variant="ghost"
        aria-label={t("header_v3.notification_settings")}
        onClick={() => {
          void navigate({
            to: memberProfileModalPaths.notifications,
            state: previousLocationState,
          });
        }}
      />
    </Tooltip>
  );
};
